<template>
  <div class="content ht-100v pd-0 bg-white">
    <div class="content-header">
        <div class="d-flex">
          <div class="mg-r-5 d-flex" v-if="mode==2">
            <loc-type-cascader v-model="filter.type" locTypekey="auditProblemType" @loctype-selected="locTypeChanged" disableAdd size="mini" />
            <DatePicker class="mg-l-10"
              v-model="filter.start"
              placeholder="Он"
              type="year"
              size="mini"
              :format="'yyyy'"
              :value-format="'yyyy'"
            ></DatePicker>
          </div>
          <div class="mg-r-5" v-if="mode!=2">
            <DatePicker
              v-model="filter.start"
              placeholder="Огноо эхлэх"
              type="date"
              size="mini"
              :format="'yyyy-MM-dd'"
              :value-format="'yyyy-MM-dd'"
            ></DatePicker>
          </div>
          <div class="mg-r-5" v-if="mode!=2">
            <DatePicker
              v-model="filter.end"
              placeholder="Огноо дуусах"
              type="date"
              size="mini"
              :format="'yyyy-MM-dd'"
              :value-format="'yyyy-MM-dd'"
            ></DatePicker>
          </div>
          <div class="btn-group">
            <a @click="manageData()" class="btn btn-xs btn-brand-01">Ачааллах</a>
            <a @click="downloadRep()" class="btn btn-xs btn-brand-02">Excel</a>
          </div>
        </div>

        <nav class="nav">
          <div class="dropdown">
            <a href="" class="btn btn-primary" data-toggle="dropdown">Тайлан сонгох
              <feather type="chevron-down"></feather>
            </a>

            <div class="dropdown-menu tx-13">
              <ul class="nav nav-pills flex-column">
                <li class="nav-item">
                  <a style="padding: 0.5rem 1rem" class="nav-link" role="button" @click="manageData(1)">Хяналт шалгалт</a>
                </li>
                <li class="nav-item">
                  <a style="padding: 0.5rem 1rem" class="nav-link" role="button" @click="manageData(2)">Акт биелэлт</a>
                </li>
                <li class="nav-item">
                  <a style="padding: 0.5rem 1rem" class="nav-link" role="button" @click="manageData(3)">СЯ-ны зөрчлийн нэгтгэл</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
    </div>
    <div class="content-body pd-0-f">
      <div class="container pd-0-f" id="printablePage">
        <!-- <div class="d-flex">
          <h4>Хяналт шалгалт</h4>
          <div class="mg-l-auto"></div>
        </div> -->
        
        <table v-if="mode==1" class="table table-bordered table-sm table-responsive table-striped">
          <thead class="text-center">
            <tr>
              <th class="bg-clr-1" style="width: 50px" rowspan="4">д/д/</th>
              <th class="bg-clr-1" rowspan="4"> Байгууллагын нэр</th>
              <th class="bg-clr-2" colspan="13"> ДА, СХШ хийсэн мэдээ</th>
            </tr>
            <tr>
              <th class="bg-clr-3" colspan="6">Төлөвлөгөөт</th>
              <th class="bg-clr-4" colspan="3"> Төлөвлөгөөт бус 		</th>
              <th class="bg-clr-5" colspan="3"> ҮҮНЭЭС</th>
              <th class="bg-clr-6 verticalTableHeader" rowspan="3">Нийт хяналт шалгалтын тоо</th>
            </tr>
            <tr>
              <th class="bg-clr-3" colspan="2"> Дотоод аудит</th>
              <th class="bg-clr-3" colspan="2"> СХШалгалт</th>
              <th class="bg-clr-3" colspan="2">Хамтарсан</th>

              <th class="bg-clr-4 verticalTableHeader" rowspan="2">Дотоод аудит</th>
              <th class="bg-clr-4 verticalTableHeader" rowspan="2"> СХШалгалт </th>
              <th class="bg-clr-4 verticalTableHeader" rowspan="2">Хамтарсан</th>

              <th class="bg-clr-5 verticalTableHeader" rowspan="2">Дотоод аудит</th>
              <th class="bg-clr-5 verticalTableHeader" rowspan="2"> СХШалгалт </th>
              <th class="bg-clr-5 verticalTableHeader" rowspan="2">Хамтарсан</th>
            </tr>
            <tr>
              <th class="bg-clr-3 verticalTableHeader"> Төлөвлөгөө</th>
              <th class="bg-clr-3 verticalTableHeader">  Гүйцэтгэл </th>
              <th class="bg-clr-3 verticalTableHeader"> Төлөвлөгөө</th>
              <th class="bg-clr-3 verticalTableHeader">  Гүйцэтгэл </th>
              <th class="bg-clr-3 verticalTableHeader"> Төлөвлөгөө</th>
              <th class="bg-clr-3 verticalTableHeader">  Гүйцэтгэл </th>
            </tr>
          </thead>
          <tbody class="text-center">
            <template v-for="(ot, oi) in orgTypes">
              <tr class="bg-clr-8 font-weight-bold">
                <td class="text-left" colspan="2">{{romanize(oi+1)}} .{{ot.name}}</td>
                <td colspan="20"></td>
              </tr>
              <tr v-for="(t,i) in organizations.filter(x=>x.typeId==ot.id)" :key="`1_${ot.id}_${i}`">
                <td class="bg-clr-1 text-right">{{i+1}}</td>
                <td class="text-left">{{t.organizationName}}</td>

                <td class="tx-11">{{t.plannedAuditPlanCount | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.plannedAuditExecuteCount | formatMoney(0, ".", ",")}}</td>

                <td class="tx-11">{{t.plannedShalgaltPlanCount | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.plannedShalgaltExecuteCount | formatMoney(0, ".", ",")}}</td>

                <td class="tx-11">{{t.plannedPartneredPlanCount | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.plannedPartneredExecuteCount | formatMoney(0, ".", ",")}}</td>
                
                <td class="tx-11">{{t.notPlannedAuditCount | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.notPlannedShalgaltCount | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.notPlannedPartneredCount | formatMoney(0, ".", ",")}}</td>

                <td class="tx-11">{{t.sumAuditCount | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.sumShalgaltCount | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.sumPartneredCount | formatMoney(0, ".", ",")}}</td>

                <td class="tx-11">{{t.allCount | formatMoney(0, ".", ",")}}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <table v-else-if="mode==2" class="table table-bordered table-sm">
          <thead class="text-center">
            <tr>
              <th class="bg-clr-1" rowspan="2">д/д/</th>
              <th class="bg-clr-1" rowspan="2"> Байгууллагын нэр</th>
              <th class="bg-clr-5" colspan="3">{{(curTpe == null || curTpe=='')?'Нийт': curTpe}}		</th>
              <th class="bg-clr-1" colspan="4">Үүнээс</th>
              <!-- <th class="bg-clr-1" rowspan="2" style="width: 20px"><p>Торгосон торгууль</p></th> -->
              <th class="bg-clr-5" colspan="3">Шийдвэрлэсэн		</th>
              <th class="bg-clr-1" colspan="4">Үүнээс			</th>
              <!-- <th class="bg-clr-1" rowspan="2">Барагдсан торгууль</th> -->
              <th class="bg-clr-5" colspan="3">Үлдэгдэл		</th>
              <th class="bg-clr-1" colspan="4">Үүнээс			</th>
              <!-- <th class="bg-clr-1" rowspan="2">Торгуулийн үлдэгдэл</th> -->
            </tr>
            <tr>
              <td class="verticalTableHeader"> Өмнөх онд <br />тогтоосон төлбөр <br />зөрчлийн үлдэгдлийн дүн </td>
              <td class="verticalTableHeader">Тайлант онд <br /> тогтоосон төлбөр <br /> зөрчлийн дүн</td>
              <td class="verticalTableHeader">НИЙТ ДҮН</td>

              <td class="verticalTableHeader">Улсын Төсөвт</td>
              <td class="verticalTableHeader">Тухайн байгууллагад</td>
              <td class="verticalTableHeader">Орон нутгийн төсөвт</td>
              <td class="verticalTableHeader"> Хуулийн байгууллагад <br /> шилжүүлсэн</td>

              <td class="verticalTableHeader">Өмнөх оны үлдэгдлээс</td>
              <td class="verticalTableHeader">Тайлант онд <br /> тогтоосон дүнгээс</td>
              <td class="verticalTableHeader">НИЙТ ДҮН</td>

              <td class="verticalTableHeader">Улсын Төсөвт</td>
              <td class="verticalTableHeader">Тухайн байгууллагад</td>
              <td class="verticalTableHeader">Орон нутгийн төсөвт</td>
              <td class="verticalTableHeader"> Хуулийн байгууллагад<br />  шилжүүлсэн</td>

              <td class="verticalTableHeader">Өмнөх оны үлдэгдэл</td>
              <td class="verticalTableHeader">Тайлант онд <br /> тогтоосон үлдэгдэл</td>
              <td class="verticalTableHeader">НИЙТ ҮЛДЭГДЭЛ</td>

              <td class="verticalTableHeader">Улсын Төсөвт</td>
              <td class="verticalTableHeader">Тухайн байгууллагад</td>
              <td class="verticalTableHeader">Орон нутгийн төсөвт</td>
              <td class="verticalTableHeader"> Хуулийн байгууллагад <br /> шийдвэрлэгдээгүй</td>
              
            </tr>
          </thead>
          <tbody class="text-center">
            <template v-for="(ot, oi) in orgTypes">
              <tr class="bg-clr-8 font-weight-bold">
                <td class="text-left" colspan="2">{{romanize(oi+1)}} .{{ot.name}}</td>
                <td colspan="21"></td>
              </tr>
              <tr v-for="(t,i) in akts.filter(x=>x.typeId==ot.id)" :key="`2_${ot.id}_${i}`">
                
                <td class="bg-clr-1" >{{i+1}}</td>
                <td class="text-left">{{t.organizationName}}</td>

                <td class="tx-11">{{t.sum.beforeYear | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.sum.currentYear | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.sum.sum | formatMoney(0, ".", ",")}}</td>

                <td class="tx-11">{{t.sum.zadargaa.uls | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.sum.zadargaa.currentOrg | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.sum.zadargaa.oronNutag | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.sum.zadargaa.legalOrg | formatMoney(0, ".", ",")}}</td>

                <!-- <td></td> -->

                <td class="tx-11">{{t.paid.beforeYear | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.paid.currentYear | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.paid.sum | formatMoney(0, ".", ",")}}</td>

                <td class="tx-11">{{t.paid.zadargaa.uls | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.paid.zadargaa.currentOrg | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.paid.zadargaa.oronNutag | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.paid.zadargaa.legalOrg | formatMoney(0, ".", ",")}}</td>

                <!-- <td></td> -->

                <td class="tx-11">{{t.uld.beforeYear | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.uld.currentYear | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.uld.sum | formatMoney(0, ".", ",")}}</td>

                <td class="tx-11">{{t.uld.zadargaa.uls | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.uld.zadargaa.currentOrg | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.uld.zadargaa.oronNutag | formatMoney(0, ".", ",")}}</td>
                <td class="tx-11">{{t.uld.zadargaa.legalOrg | formatMoney(0, ".", ",")}}</td>

                <!-- <td></td> -->
              </tr>
              

            </template>
          </tbody>
        </table>
        <table v-else-if="mode==3" class="table table-bordered table-sm table-striped">
            <thead class="text-center">
              <tr>
                <th class="bg-clr-1" rowspan="2">Д/д</th>
                <th class="bg-clr-1" rowspan="2">Байгууллагын нэр</th>
                <th class="bg-clr-5" colspan="2">Албан шаардлага</th>
                <th class="bg-clr-7" colspan="2">Актын тоо</th>
                <th class="bg-clr-4" rowspan="2">Нийт зөрчлийн дүн</th>

                <th class="bg-clr-1" colspan="4">Дутуу ноогдуулсан</th>
                <th class="bg-clr-1" colspan="3">Төрийн өмчийн хөрөнгийг</th>
                <th class="bg-clr-1" colspan="3">Төсвийн мөнгөн хөрөнгийг</th>

                <th class="bg-clr-1 verticalTableHeader" rowspan="2">Үндсэн баримтгүй зарцуулсан <br />болон данс бүртгэлд тусгаагүй</th>
                <th class="bg-clr-1 verticalTableHeader" rowspan="2">Өр авлага үндэслэлгүй хаасан</th>
                <th class="bg-clr-1 verticalTableHeader" rowspan="2">Дутуу болон <br />илүү олгосон <br />цалин хөлс, нөхвөр</th>
                <th class="bg-clr-1 verticalTableHeader" rowspan="2">Ашиглаж дутагдуулсан хөрөнгө</th>
                <th class="bg-clr-1" rowspan="2">Бусад</th>
              </tr>
              <tr>
                <th class="bg-clr-5 verticalTableHeader">АШ-ын тоо</th>
                <th class="bg-clr-5 verticalTableHeader">Мөнгөн дүн</th>

                <th class="bg-clr-7 verticalTableHeader">Актын тоо</th>
                <th class="bg-clr-7 verticalTableHeader">Актаар тогтоосон <br /> төлбөр зөрчлийн дүн</th>

                <th class="bg-clr-1 verticalTableHeader">Албан татвар, төлбөр, хураамж</th>
                <th class="bg-clr-1 verticalTableHeader">Түрээсийн төлбөр</th>
                <th class="bg-clr-1 verticalTableHeader">Төрийн өмчийн ногдол ашиг</th>
                <th class="bg-clr-1 verticalTableHeader">ЭМД, НДШ хураамж</th>

                <th class="bg-clr-1 verticalTableHeader">ТУЗ-ийн гишүүн төрийн <br />албан хаагчид  эрх <br />бүхий байгууллагаас тогтоосон<br />  цалин хөлснөөс бусад  шан харамж, <br /> урамшуулал олгосон</th>
                <th class="bg-clr-1 verticalTableHeader">Данс бүртгэлд тусгаагүй, <br />тушаал шийдвэргүй акталсан</th>
                <th class="bg-clr-1 verticalTableHeader">Эрх бүхий байгууллагын <br />шийдвэргүйгээр ой баяр тэмдэглэх,<br /> хандив, шагнал, <br />бэлэг дурсгалд олгох</th>

                <th class="bg-clr-1 verticalTableHeader">Бусдад зээлдүүлж түр ашиглуулсан</th>
                <th class="bg-clr-1 verticalTableHeader">Зориулалт бусаар зарцуулсан</th>
                <th class="bg-clr-1 verticalTableHeader">Хандивлаж ивээн тэтгэсэн,<br /> их хэмжээгээр олгосон <br />шагнал бэлэг дурсгал</th>

              </tr>
            </thead>
            <tbody class="text-center">
              <template v-for="(ot, oi) in orgTypes">
                <tr v-for="(t,i) in yams.filter(x=>x.typeId==ot.id)" :key="`3_${ot.id}_${i}`">
                  <td>{{i+1}}</td>
                  <td class="text-left">{{t.organizationName}}</td>

                  <td class="bg-clr-5 tx-11">{{t.albanCount | formatMoney(0, ".", ",")}}</td>
                  <td class="bg-clr-5 tx-11">{{t.albanBudget  | formatMoney(0, ".", ",")}}</td>
                  <td class="bg-clr-7 tx-11">{{t.actCount | formatMoney(0, ".", ",")}}</td>
                  <td class="bg-clr-7 tx-11">{{t.actBudget | formatMoney(0, ".", ",")}}</td>
                  <td class="bg-clr-4 tx-11">{{t.allBudget | formatMoney(0, ".", ",")}}</td>

                  <td class="tx-11">{{t.zadargaa.tatvar_1 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.turees_2 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.nogdolAshig_3 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.emdndsh_4 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.tuz_5 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.dans_6 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.handiv_7 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.zeel_8 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.zooriulaltBus_9 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.iveenTetgeh_10 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.undsenBarimtgui_11 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.urAvlagaHaasan_12 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.tsalin_13 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.dutsanHurungu_14 | formatMoney(0, ".", ",")}}</td>
                  <td class="tx-11">{{t.zadargaa.busad_15 | formatMoney(0, ".", ",")}}</td>
                </tr>
                
                <tr class="bg-clr-8 font-weight-bold">
                  <td class="text-left" colspan="2">{{romanize(oi+1)}} .{{ot.name}}</td>
                  <td colspan="20"></td>
                </tr>
              </template>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { mapActions } from "vuex";
import { request } from "@/api/all";

import { DatePicker } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { formatMoney } from "../../../../libs/tools";

import { romanize } from "@/libs/tools";

const moment = require("moment");

export default {
  components:{
    DatePicker,
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data(){
    return{
      mode: 1,
      tasks: [],
      organizations: [],
      akts: [],
      yams: [],

      orgTypes: [],

      filter:{
        start:  moment().startOf('year').format('YYYY-MM-DD'),
        end: moment(new Date()).format("YYYY-MM-DD"),
        type: null,
      },
      curTpe: null
    }
  },
  mounted(){
    this.handleAside({ minimize: true, maximize: false });
    this.manageData();
  },
  methods: {
    ...mapActions(["handleLoading", "handleAside", "handleUserInfoModal"]),
    romanize(v) {
      return romanize(v);
    },
    downloadRep(){      
      window.open('data:application/vnd.ms-excel,' + encodeURIComponent($('#printablePage').html()));
    },
    locTypeChanged(e){
      //console.log('e', e);
      this.filter.type= e.id;
      if(e.id==null){
        //console.log('step 2');
        this.curTpe= null;
      }else{
        this.curTpe= e.dta.filter(x=>x.id==e.id)[0]['title'];
      }

      this.manageData();
    },
    manageData(md) {
      if(md!=undefined && md!=null && md>0){
        this.mode= md;
      }

      if(this.mode==1) {
        this.loadTsks();
      }else if(this.mode==2) {
        this.loadAkt();
      }else if(this.mode==3) {
        this.loadYam();
      }
    },
    loadTsks(){
      request({
        api: { 
          //method: "POST", 
          method: "GET", 
          //url: "TaskCore/GetCoreList",
          url: "Audit/ReportAuditPlanExecution",
        },
        params:{
          startDate: this.filter.start, endDate: this.filter.end
        },
        // data: {
        //   ot: 154,
        //   skip: 0,
        //   size: 500,
        //   model: { isPublic: true }
        // },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //this.tasks = res.data.tasks;
          this.organizations= res.data.organizations;
          this.orgTypes= res.data.orgTypes;
        }
      });
    },
    loadAkt(){
      request({
        api: { 
          method: "GET", 
          url: "Audit/ReportAuditProblemExecution",
        },
        params:{
          //startDate: this.filter.start, endDate: this.filter.end, 
          year: this.filter.start,
          typeId: this.filter.type
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.akts= res.data.organizations;
          this.orgTypes= res.data.orgTypes;
          
          //console.log('res', res);
        }
      });
    },
    loadYam(){
      request({
        api: { 
          method: "GET", 
          url: "Audit/ReportAuditProblemMinistryFinance",
        },
        params:{
          startDate: this.filter.start, endDate: this.filter.end
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.yams= res.data.organizations;
          this.orgTypes= res.data.orgTypes;
         //console.log('res', res);
        }
      });
    },
  }
}
</script>

<style>
  .bg-clr-1{
    background-color: rgba(141, 180, 226, 1);
  }
  .bg-clr-2{
    background-color:rgba(247, 150, 70, 1);
  }
  .bg-clr-3{
    background-color:rgba(235, 241, 222, 1);
  }
  .bg-clr-4{
    background-color: rgba(228, 223, 236, 1);
  }
  .bg-clr-5{
    background-color: rgba(252, 213, 180, 1);
  }
  .bg-clr-6{
    background-color: rgba(242, 220, 219, 1);
  }
  .bg-clr-7{
    background-color: rgba(218, 238, 249, 1);
  }
  .bg-clr-8{
    background-color: rgba(196, 189, 151, 1) !important;
  }
  .verticalTableHeader{
    writing-mode: vertical-rl;
    text-orientation: mixed;
    line-height: 1 !important;
  }
</style>